import {AUTHORIZE, UNAUTHORIZE, SET_TWO_STEP_AUTHORIZATION_DATA} from '../actions/actionTypes';

const initialState = {
    isAuthorized: false,
    accessToken: null,
    refreshToken: null,
    twoStepData: {}
};

export default (state = initialState, {type, ...payload}) => {
    switch (type) {
        case AUTHORIZE: {
            const {accessToken, refreshToken} = payload;

            return {...state, isAuthorized: true, accessToken, refreshToken};
        }

        case SET_TWO_STEP_AUTHORIZATION_DATA: {
            return {...state, twoStepData: payload};
        }

        case UNAUTHORIZE: {
            return {
                ...state,
                isAuthorized: false,
                accessToken: null,
                refreshToken: null
            };
        }

        default: {
            return state;
        }
    }
};
